"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalForm = void 0;
const useModalForm_1 = require("@reactionable/core/lib/ui/modal/useModalForm");
const ModalForm_1 = require("./ModalForm");
function useModalForm(props) {
    return useModalForm_1.useModalForm(Object.assign(Object.assign({}, props), { Component: ModalForm_1.ModalForm }));
}
exports.useModalForm = useModalForm;
//# sourceMappingURL=useModalForm.js.map